import Vue from 'vue'
import App from '@/App.vue'
import router from './router'

// store
import store from '@/shared/store'

// api
import '@/shared/services/api'

// plugins
import '@/shared/plugins'

/// layout AdminLTE
//import '@/shared/layouts/adminlte'
import './shared/layouts/adminlte'

// filters
import '@/shared/common/filters'

import '@/shared/assets/css/main.scss'
import './shared/assets/css/novo-layout.scss'

// Configurações do módulo
Vue.prototype.$urlBase = '/assinatura_digital'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')